import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { getbulk, gettoken } from '../Localstorage/Store';

const RedirectionComp = ({ page, bulk = false }) => {
  const bulkstatus = getbulk();
  const navigate = useNavigate();
  const [tok, setTok] = useState(null);
  const [bulkStatus, setbulkStatus] = useState(false);

  useEffect(() => {
    const token = gettoken();
    setTok(token);

    if (bulk && bulkstatus) {
      setbulkStatus(true);
    }

    if (!token || token === undefined) {
      navigate('/client-login'); 
    }
  }, [bulk, bulkstatus, navigate]);

  return (tok ? page : null);
}

export default RedirectionComp;
